import { type ComponentPropsWithoutRef, type ReactElement } from 'react'

import { generateRandomKey } from '@lib/utils/strings'

import { LogoSprites } from '@constants/enums/sprites'

import { Column } from '@components/ui-core/column/column'
import { ContentWrapper } from '@components/ui-core/content-wrapper/content-wrapper'
import { FooterPrivacyButton } from '@components/ui-core/footer/footer-privacy-button'
import { Logo } from '@components/ui-core/logo/logo'
import { NavLink } from '@components/ui-core/nav-links/nav-link'
import { Text } from '@components/ui-core/text/text'
import { type NavLinkItem } from '@components/ui-core/types'
import { Wordmark } from '@components/ui-core/wordmark/wordmark'

import styles from './footer.module.css'
export interface FooterProps extends ComponentPropsWithoutRef<'footer'> {
  navColumns?: NavLinkItem[]
}

export function Footer({ navColumns, ...rest }: FooterProps): ReactElement {
  return (
    <footer className={styles.footer} {...rest}>
      <ContentWrapper className={styles.footerContent}>
        <Column gap="6x" className={styles.logo}>
          <Logo variant={LogoSprites.Superhuman} />
          <Text as="h3" className={styles.logoTitle}>
            Builders of Superhuman Platform apps
          </Text>
        </Column>
        {navColumns?.length && (
          <nav className={styles.content}>
            {navColumns.map(navColumn => (
              <div className={styles.contentItem} key={generateRandomKey()}>
                <Text as="h3" fontWeight="bold" className={styles.contentItemTitle}>
                  {navColumn.label}
                </Text>
                {navColumn.links?.length && (
                  <Column as="ul" gap="4x">
                    {navColumn.links.map(link => (
                      <li key={generateRandomKey()}>
                        <NavLink
                          href={link.href}
                          label={link.label}
                          icon={link.icon}
                          openIn={link.openIn}
                          className={styles.navLink}
                        />
                      </li>
                    ))}
                    {navColumn.label === 'Legal' && (
                      <li key={generateRandomKey()}>
                        <FooterPrivacyButton className={styles.navLink} />
                      </li>
                    )}
                  </Column>
                )}
              </div>
            ))}
          </nav>
        )}
        <Wordmark className={styles.wordmark} />
      </ContentWrapper>
    </footer>
  )
}
